import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';

import { CopyFormDialogBase } from '../copy-form-base/copy-form-base.dialog';
import { Form } from '../../models/form-builder/form.model';
import { FormBuilderService } from '../../services/form-builder.service';

@Component({
    selector: 'app-copy-form',
    templateUrl: './copy-form.dialog.html',
    styleUrls: [
        '../copy-form-base/copy-form-base.dialog.scss',
        './copy-form.dialog.scss'
    ],
    standalone: false
})
export class CopyFormDialog extends CopyFormDialogBase implements OnInit {
    // Properties.
    //private formCopyName: string = null;
    //private copyInProgress: boolean = false;
    //private copyErrorOccurred: boolean = false;

    // Constructor.
    public constructor(public dialogRef: MatDialogRef<CopyFormDialog>,
        @Inject(MAT_DIALOG_DATA) public formToCopy: Form,
        private formBuilderService: FormBuilderService)
    {
        super();

        this.formCopyName = `${this.formToCopy.name} Copy`;

        dialogRef.disableClose = true; // Disable closing the dialogue when the user clicks on the page.

        return;
    }

    // Life cycle methods.
    public ngOnInit(): void {
        return;
    }

    // Accessor methods.
    public get SourceFormName(): string {
        return (this.formToCopy.name);
    }

    public startFormCopy(): void {
        // Copy the form.
        this.copyInProgress = true;

        this.formBuilderService.copyAs(this.formToCopy.id, this.formCopyName).then(copiedForm => {
            // Dismiss this dialogue.
            this.dialogRef.close(copiedForm);
        });

        return;
    }
}
